import { Component, OnInit, OnDestroy } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MenuItem, MessageService } from 'primeng/api';
import { first, Subscription } from 'rxjs';
import { VendorSignUp } from 'src/app/models/vendor-details.model';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { BankDetailService } from 'src/app/services/bank-details.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { FarmersDetailsService } from 'src/app/services/farmers-details.service';
import { TicketService } from 'src/app/services/ticketservice';
import { VendorDashboardService } from 'src/app/services/vendor-dashboard.service';
import { DatePipe } from '@angular/common';
import { IpAddressService } from 'src/app/services/ip-address.service';

@Component({
  selector: 'app-vendor-signup',
  templateUrl: './vendor-signup.component.html',
  styleUrls: ['./vendor-signup.component.scss'],
  providers: [MessageService, TicketService, DatePipe],
})
export class VendorSignupComponent implements OnInit {
  items: MenuItem[];
  activeIndex: number = 0;
  vendorForm: FormGroup;
  otpValidationForm: FormGroup;
  subscription: Subscription;
  countries: { code: string; name: string }[] = []
  // vendorTypes = [
  //   { name: 'Manufacturer', code: 'manufacturer' },
  //   { name: 'Supplier', code: 'supplier' },
  // ];
  vendorTypes: any[] = [];
  indiaStates: string[] = [
    'Andhra Pradesh',
    'Arunachal Pradesh',
    'Assam',
    'Bihar',
    'Chhattisgarh',
    'Goa',
    'Gujarat',
    'Haryana',
    'Himachal Pradesh',
    'Jharkhand',
    'Karnataka',
    'Kerala',
    'Madhya Pradesh',
    'Maharashtra',
    'Manipur',
    'Meghalaya',
    'Mizoram',
    'Nagaland',
    'Odisha',
    'Punjab',
    'Rajasthan',
    'Sikkim',
    'Tamil Nadu',
    'Telangana',
    'Tripura',
    'Uttar Pradesh',
    'Uttarakhand',
    'West Bengal',
    'Chandigarh',
    'Dadra and Nagar Haveli and Daman and Diu',
    'Lakshadweep',
    'Delhi',
    'Puducherry',
    'Ladakh',
    'Jammu and Kashmir',
  ];
  isIndiaSelected: boolean = false;
  bankList: any;
  filteredStates: any[] = [];
  selectedCountryCode: string;
  // uploadOptions = [
  //   { name: 'Aadhar', code: 'aadhar_path' },
  //   { name: 'PAN', code: 'pan_path' },
  //   { name: 'BIS Certificate', code: 'BIS_Certificate_path' },
  //   { name: 'Bank Guarantee', code: 'Bank_Guarantee_path' },
  //   { name: 'Demand Draft', code: 'Demand_Draft_path' },
  //   { name: 'TAN', code: 'TAN_path' },
  //   { name: 'GST Certificate', code: 'GST_Certificate_path' },
  //   { name: 'Trade Mark', code: 'TradeMark_Doc' },
  //   { name: 'Registration Certificate', code: 'Registration_Certificate_path' },
  //   { name: 'Undertaking', code: 'Undertaking_path' },
  //   { name: 'Predispatch Report', code: 'Predispatch_Report_path' },
  //   { name: 'Experience Certificate', code: 'Experience_Certificate' },
  //   { name: 'Other', code: 'other' },
  // ];
  uploadOptions: any = [];
  documentList: any = [];
  filteredBankList: any[];
  selectedFile: File | null = null;
  bankAccount = { bankName: '', ifscCode: '' };
  todayDate: Date;
  isSubmitted: boolean = false;
  vendorID: string = '';

  public subscriptions: any = []
  public subjectSub: any;
  public selectedYear: any;

  public otpSentMessage: any = null;
  public openValidationDialog: boolean = false;
  public isEmailVerified: boolean = false;
  public isMobileVerified: boolean = false;
  public validationType: any = null;
  public programListwithRate: any = [];
  public ipAddress: any;

  constructor(
    private formBuilder: FormBuilder,
    private productService: BankDetailService,
    private ticketService: TicketService,
    private messageService: MessageService,
    private _personalDetalSer: FarmersDetailsService,
    private loader: AppLoaderService,
    private activityRecordService: ActivityRecordService,
    public router: Router,
    private cryptoJsService: CryptoJsService,
    private vendorService: VendorDashboardService,
    private datePipe: DatePipe,
    private ipService: IpAddressService,
    private cryptoJs: CryptoJsService,
  ) { }

  ngOnInit() {
    this.getBankNameList();
    this.loadVendorRegType();
    this.getComponentMaster();
    setTimeout(() => {
      this.loadCountries();
    }, 100)
    this.items = [
      { label: 'Authentication' },
      { label: 'Basic Information' },
      { label: 'Upload Supporting Documents' },
    ];

    this.otpValidationForm = this.formBuilder.group({
      otp: ['',
      [
        Validators.required,     
      ],
      ],
    })

    this.vendorForm = this.formBuilder.group({
      email: [
      '',
      [
        Validators.required,
        Validators.email,
        Validators.pattern(/^[a-zA-Z0-9._%+-]+@gmail\.com$/),
      ],
      ],
      password: ['', [Validators.required, Validators.minLength(8)]],
      confirmPassword: ['', Validators.required],
      vendorType: ['', Validators.required],
      VenSupManDetails1: [''],
      VenSupManDetails2: [''],
      VenSupManDetails3: [''],
      vendorName: ['', Validators.required],
      officialEmailId: ['', [Validators.required, Validators.email]],
      gstNumber: [
      '',
      [Validators.required, Validators.pattern(/^[A-Z0-9]{15}$/)],
      ],
      country: ['', Validators.required],
      state: ['', Validators.required],
      address: ['', Validators.required],
      city: ['', Validators.required],
      dob: [null, Validators.required],
      mobile: [
      '',
      [Validators.required, Validators.minLength(10), Validators.maxLength(10)],
      ],
      panNo: [
      '',
      [
        Validators.required,
        Validators.minLength(10),
        Validators.maxLength(10),
        Validators.pattern('[A-Z]{5}[0-9]{4}[A-Z]{1}'),
      ],
      ],
      tanNo: [
      '',
      [
        Validators.minLength(10),
        Validators.maxLength(10),
        Validators.pattern('[A-Z]{4}[0-9]{5}[A-Z]{1}'),
      ],
      ],
      bankAccountNumber: ['', Validators.required],
      bankName: ['', Validators.required],
      iFSCCode: ['', Validators.required],
      ddAmount: [0, Validators.required],
      ddNumber: ['', [Validators.required, Validators.pattern(/^[0-9]+$/)]],
      ddBankName: ['', Validators.required],
      ddDate: ['', Validators.required],
      programme: ['', Validators.required],
    },
    {
      validator: this.passwordMatchValidator('password', 'confirmPassword'),
    });
    // });

    // this.filteredStates = this.indiaStates;
    // this.vendorForm.get('state').valueChanges.subscribe(stateCode => {
    //   this.selectCountryByState(stateCode);
    // });
    this.vendorForm.addControl(
      'documentType',
      this.formBuilder.control('')
    );

    this.ticketService.paymentComplete$.subscribe((personalInformation) => {
      this.messageService.add({
        severity: 'success',
        summary: 'Order submitted',
        detail: `Dear ${personalInformation.firstname} ${personalInformation.lastname}, your order is completed.`,
      });
    });
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
    if (this.subjectSub) {
      this.subjectSub.unsubscribe();
    }
  }

  loadCountries() {
    this.countries = [
      { code: 'IN', name: 'India' },
      { code: 'AF', name: 'Afghanistan' },
      { code: 'AL', name: 'Albania' },
      { code: 'DZ', name: 'Algeria' },
      { code: 'AD', name: 'Andorra' },
      { code: 'AO', name: 'Angola' },
      { code: 'AG', name: 'Antigua and Barbuda' },
      { code: 'AR', name: 'Argentina' },
      { code: 'AM', name: 'Armenia' },
      { code: 'AU', name: 'Australia' },
      { code: 'AT', name: 'Austria' },
      { code: 'AZ', name: 'Azerbaijan' },
      { code: 'BS', name: 'Bahamas' },
      { code: 'BH', name: 'Bahrain' },
      { code: 'BD', name: 'Bangladesh' },
      { code: 'BB', name: 'Barbados' },
      { code: 'BY', name: 'Belarus' },
      { code: 'BE', name: 'Belgium' },
      { code: 'BZ', name: 'Belize' },
      { code: 'BJ', name: 'Benin' },
      { code: 'BT', name: 'Bhutan' },
      { code: 'BO', name: 'Bolivia' },
      { code: 'BA', name: 'Bosnia and Herzegovina' },
      { code: 'BW', name: 'Botswana' },
      { code: 'BR', name: 'Brazil' },
      { code: 'BN', name: 'Brunei' },
      { code: 'BG', name: 'Bulgaria' },
      { code: 'BF', name: 'Burkina Faso' },
      { code: 'BI', name: 'Burundi' },
      { code: 'CV', name: 'Cabo Verde' },
      { code: 'KH', name: 'Cambodia' },
      { code: 'CM', name: 'Cameroon' },
      { code: 'CA', name: 'Canada' },
      { code: 'CF', name: 'Central African Republic' },
      { code: 'TD', name: 'Chad' },
      { code: 'CL', name: 'Chile' },
      { code: 'CN', name: 'China' },
      { code: 'CO', name: 'Colombia' },
      { code: 'KM', name: 'Comoros' },
      { code: 'CG', name: 'Congo (Congo-Brazzaville)' },
      { code: 'CR', name: 'Costa Rica' },
      { code: 'HR', name: 'Croatia' },
      { code: 'CU', name: 'Cuba' },
      { code: 'CY', name: 'Cyprus' },
      { code: 'CZ', name: 'Czechia (Czech Republic)' },
      { code: 'CD', name: 'Democratic Republic of the Congo' },
      { code: 'DK', name: 'Denmark' },
      { code: 'DJ', name: 'Djibouti' },
      { code: 'DM', name: 'Dominica' },
      { code: 'DO', name: 'Dominican Republic' },
      { code: 'EC', name: 'Ecuador' },
      { code: 'EG', name: 'Egypt' },
      { code: 'SV', name: 'El Salvador' },
      { code: 'GQ', name: 'Equatorial Guinea' },
      { code: 'ER', name: 'Eritrea' },
      { code: 'EE', name: 'Estonia' },
      { code: 'SZ', name: 'Eswatini (formerly Swaziland)' },
      { code: 'ET', name: 'Ethiopia' },
      { code: 'FJ', name: 'Fiji' },
      { code: 'FI', name: 'Finland' },
      { code: 'FR', name: 'France' },
      { code: 'GA', name: 'Gabon' },
      { code: 'GM', name: 'Gambia' },
      { code: 'GE', name: 'Georgia' },
      { code: 'DE', name: 'Germany' },
      { code: 'GH', name: 'Ghana' },
      { code: 'GR', name: 'Greece' },
      { code: 'GD', name: 'Grenada' },
      { code: 'GT', name: 'Guatemala' },
      { code: 'GN', name: 'Guinea' },
      { code: 'GW', name: 'Guinea-Bissau' },
      { code: 'GY', name: 'Guyana' },
      { code: 'HT', name: 'Haiti' },
      { code: 'HN', name: 'Honduras' },
      { code: 'HU', name: 'Hungary' },
      { code: 'IS', name: 'Iceland' },
      { code: 'ID', name: 'Indonesia' },
      { code: 'IR', name: 'Iran' },
      { code: 'IQ', name: 'Iraq' },
      { code: 'IE', name: 'Ireland' },
      { code: 'IL', name: 'Israel' },
      { code: 'IT', name: 'Italy' },
      { code: 'JM', name: 'Jamaica' },
      { code: 'JP', name: 'Japan' },
      { code: 'JO', name: 'Jordan' },
      { code: 'KZ', name: 'Kazakhstan' },
      { code: 'KE', name: 'Kenya' },
      { code: 'KI', name: 'Kiribati' },
      { code: 'KW', name: 'Kuwait' },
      { code: 'KG', name: 'Kyrgyzstan' },
      { code: 'LA', name: 'Laos' },
      { code: 'LV', name: 'Latvia' },
      { code: 'LB', name: 'Lebanon' },
      { code: 'LS', name: 'Lesotho' },
      { code: 'LR', name: 'Liberia' },
      { code: 'LY', name: 'Libya' },
      { code: 'LI', name: 'Liechtenstein' },
      { code: 'LT', name: 'Lithuania' },
      { code: 'LU', name: 'Luxembourg' },
      { code: 'MG', name: 'Madagascar' },
      { code: 'MW', name: 'Malawi' },
      { code: 'MY', name: 'Malaysia' },
      { code: 'MV', name: 'Maldives' },
      { code: 'ML', name: 'Mali' },
      { code: 'MT', name: 'Malta' },
      { code: 'MH', name: 'Marshall Islands' },
      { code: 'MR', name: 'Mauritania' },
      { code: 'MU', name: 'Mauritius' },
      { code: 'MX', name: 'Mexico' },
      { code: 'FM', name: 'Micronesia' },
      { code: 'MD', name: 'Moldova' },
      { code: 'MC', name: 'Monaco' },
      { code: 'MN', name: 'Mongolia' },
      { code: 'ME', name: 'Montenegro' },
      { code: 'MA', name: 'Morocco' },
      { code: 'MZ', name: 'Mozambique' },
      { code: 'MM', name: 'Myanmar (formerly Burma)' },
      { code: 'NA', name: 'Namibia' },
      { code: 'NR', name: 'Nauru' },
      { code: 'NP', name: 'Nepal' },
      { code: 'NL', name: 'Netherlands' },
      { code: 'NZ', name: 'New Zealand' },
      { code: 'NI', name: 'Nicaragua' },
      { code: 'NE', name: 'Niger' },
      { code: 'NG', name: 'Nigeria' },
      { code: 'KP', name: 'North Korea' },
      { code: 'MK', name: 'North Macedonia' },
      { code: 'NO', name: 'Norway' },
      { code: 'OM', name: 'Oman' },
      { code: 'PK', name: 'Pakistan' },
      { code: 'PW', name: 'Palau' },
      { code: 'PS', name: 'Palestine State' },
      { code: 'PA', name: 'Panama' },
      { code: 'PG', name: 'Papua New Guinea' },
      { code: 'PY', name: 'Paraguay' },
      { code: 'PE', name: 'Peru' },
      { code: 'PH', name: 'Philippines' },
      { code: 'PL', name: 'Poland' },
      { code: 'PT', name: 'Portugal' },
      { code: 'QA', name: 'Qatar' },
      { code: 'RO', name: 'Romania' },
      { code: 'RU', name: 'Russia' },
      { code: 'RW', name: 'Rwanda' },
      { code: 'KN', name: 'Saint Kitts and Nevis' },
      { code: 'LC', name: 'Saint Lucia' },
      { code: 'VC', name: 'Saint Vincent and the Grenadines' },
      { code: 'WS', name: 'Samoa' },
      { code: 'SM', name: 'San Marino' },
      { code: 'ST', name: 'Sao Tome and Principe' },
      { code: 'SA', name: 'Saudi Arabia' },
      { code: 'SN', name: 'Senegal' },
      { code: 'RS', name: 'Serbia' },
      { code: 'SC', name: 'Seychelles' },
      { code: 'SL', name: 'Sierra Leone' },
      { code: 'SG', name: 'Singapore' },
      { code: 'SK', name: 'Slovakia' },
      { code: 'SI', name: 'Slovenia' },
      { code: 'SB', name: 'Solomon Islands' },
      { code: 'SO', name: 'Somalia' },
      { code: 'ZA', name: 'South Africa' },
      { code: 'KR', name: 'South Korea' },
      { code: 'SS', name: 'South Sudan' },
      { code: 'ES', name: 'Spain' },
      { code: 'LK', name: 'Sri Lanka' },
      { code: 'SD', name: 'Sudan' },
      { code: 'SR', name: 'Suriname' },
      { code: 'SE', name: 'Sweden' },
      { code: 'CH', name: 'Switzerland' },
      { code: 'SY', name: 'Syria' },
      { code: 'TJ', name: 'Tajikistan' },
      { code: 'TZ', name: 'Tanzania' },
      { code: 'TH', name: 'Thailand' },
      { code: 'TL', name: 'Timor-Leste' },
      { code: 'TG', name: 'Togo' },
      { code: 'TO', name: 'Tonga' },
      { code: 'TT', name: 'Trinidad and Tobago' },
      { code: 'TN', name: 'Tunisia' },
      { code: 'TR', name: 'Turkey' },
      { code: 'TM', name: 'Turkmenistan' },
      { code: 'TV', name: 'Tuvalu' },
      { code: 'UG', name: 'Uganda' },
      { code: 'UA', name: 'Ukraine' },
      { code: 'AE', name: 'United Arab Emirates' },
      { code: 'GB', name: 'United Kingdom' },
      { code: 'US', name: 'United States of America' },
      { code: 'UY', name: 'Uruguay' },
      { code: 'UZ', name: 'Uzbekistan' },
      { code: 'VU', name: 'Vanuatu' },
      { code: 'VA', name: 'Vatican City' },
      { code: 'VE', name: 'Venezuela' },
      { code: 'VN', name: 'Vietnam' },
      { code: 'YE', name: 'Yemen' },
      { code: 'ZM', name: 'Zambia' },
      { code: 'ZW', name: 'Zimbabwe' },

      // ... Add other countries here
    ];
  }

  onCountryChange(event: any): void {
    const selectedCountry = event.value.name;
    if (selectedCountry === 'India') {
      this.isIndiaSelected = true;
      let va = [];
      this.indiaStates.forEach((x) => {
        va.push({ code: x, name: x });
      });
      this.filteredStates = va;
      this.vendorForm.get('state').setValue(null);
    } else {
      this.isIndiaSelected = false;
      this.filteredStates = [];
      this.vendorForm.get('state').setValue('');
    }
  }

  // checkPasswords(group: FormGroup) {
  //   const password = group.get('password').value;
  //   const confirmPassword = group.get('confirmPassword').value;
  //   return password === confirmPassword ? null : { notMatching: true };
  // }
  passwordMatchValidator(password: string, confirmPassword: string) {
    return (formGroup: AbstractControl): { [key: string]: boolean } | null => {
      const passwordControl = formGroup.get(password);
      const confirmPasswordControl = formGroup.get(confirmPassword);

      if (!passwordControl || !confirmPasswordControl) {
        return null;
      }

      if (confirmPasswordControl.errors && !confirmPasswordControl.errors['notMatching']) {
        // Return if another validator has already found an error on the confirmPassword
        return null;
      }

      if (passwordControl.value !== confirmPasswordControl.value) {
        confirmPasswordControl.setErrors({ notMatching: true });
      } else {
        confirmPasswordControl.setErrors(null);
      }

      return null;
    };
  }

  prevPage() {
    if (this.activeIndex > 0) {
      this.activeIndex--;
    }
  }

  nextPage() {
    if (
      (!this.isEmailVerified || 
      !this.isMobileVerified ||
      this.vendorForm.value['password'] == null || this.vendorForm.value['password'] == ''  ||
      this.vendorForm.value['confirmPassword'] == null || this.vendorForm.value['confirmPassword'] == '' ||
      this.vendorForm.value['password'].length < 8 ||
      this.vendorForm.value['password'] != this.vendorForm.value['confirmPassword']) &&
      this.activeIndex == 0
    ) {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Fill all required fields with proper validation',
        });
        return;
    }

    if(this.activeIndex as number == 1 && (
      this.vendorForm.get('vendorType')?.invalid ||
      this.vendorForm.get('vendorName')?.invalid ||
      this.vendorForm.get('dob')?.invalid ||
      this.vendorForm.get('gstNumber')?.invalid ||
      this.vendorForm.get('address')?.invalid ||
      this.vendorForm.get('city')?.invalid ||
      this.vendorForm.get('country')?.invalid ||
      this.vendorForm.get('state')?.invalid ||
      this.vendorForm.get('tanNo')?.invalid ||
      this.vendorForm.get('panNo')?.invalid ||
      this.vendorForm.get('bankAccountNumber')?.invalid ||
      this.vendorForm.get('iFSCCode')?.invalid ||
      this.vendorForm.get('bankName')?.invalid ||
      this.vendorForm.get('officialEmailId')?.invalid
    )){
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Fill all required fields.',
      });
      return;
    }

    if (this.activeIndex < this.items.length - 1) {
      this.activeIndex++;
    }
  }

  getUploadOptions(id) {
    this.loader.start();
    this._personalDetalSer
      .getVendorRegDocTypeMaster(id)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();

          if (data.length > 0) {
            this.uploadOptions = data;

          } else {
            this.uploadOptions = [];

            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: `Upload otpions not loaded. ${data}`,
            });
          }
        },
        error: (err) => {
          this.loader.close();

          this.uploadOptions = [];

          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: `Error! ${err}`,
          });
        },
      });
  }

  doc: any[];
  onUpload(event, docType, uploadElement) {
    let file = event.files[0];
    let data = new FormData();
    data.append('file', file);

    // const encData = JSON.parse(this.cryptoJsService.DecryptSession(sessionStorage.getItem('dataF')));
    // const farmerconfData = new Map(encData);
    // let phNo = farmerconfData.get('farmerPh') ? farmerconfData.get('farmerPh') : '';
    const phNo = this.vendorForm.value['mobile'];

    this.loader.start();
    docType = this.vendorForm.controls['documentType'].value;
    this._personalDetalSer.uploadNewRegFile(data, phNo, docType?.DocType).subscribe(
      (resp: any) => {
        this.loader.close();
        if (resp.statusCode == 200) {
          this.documentList.push({
            documentType: docType?.DocType,
            attachmentsDoc: resp.data,
          });
          // this.grievanceForm.patchValue({ [formcontrol]: resp.data });
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'File Uploaded Successfully',
          });
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Oops! Someting went wrong.',
          });
        }
      },
      (err) => {
        this.loader.close();
        this.messageService.add({
          severity: 'error',
          summary: 'Error Message',
          detail: err,
        });
      }
    );
    uploadElement.clear();
  }

  isImage(path: string): boolean {
    return path
      ? /\.(jpg|jpeg|png|gif|bmp|svg|webp)$/.test(path.toLowerCase())
      : false;
  }

  toISOLocal(d) {
    var z = (n) => ('0' + n).slice(-2);
    var off = d.getTimezoneOffset();
    off = Math.abs(off);
    return d.getFullYear() + '-' + z(d.getMonth() + 1) + '-' + z(d.getDate());
  }

  

  mapDataToFarmersModel(): VendorSignUp {
    let farmerData = JSON.parse(window.sessionStorage.getItem('vendorDetails'));
    if (farmerData) {
      this.vendorID = farmerData.Vendor_ID;
    }
    let data: VendorSignUp = {};
    let DOB: Date;
    let values = this.vendorForm.controls.dob.value.toString().split('-');
    if (values.length) {
      values.splice(1, 0, values.shift());
      DOB = values.join('-');
    }
    data.vendorId = this.vendorID;
    data.vendor_TypeId = this.vendorForm.value['vendorType'].ID;
    data.venSupManDetails = [
      ...(this.vendorForm.value['VenSupManDetails1'] ? [{ name: this.vendorForm.value['VenSupManDetails1'] }] : []),
      ...(this.vendorForm.value['VenSupManDetails2'] ? [{ name: this.vendorForm.value['VenSupManDetails2'] }] : []),
      ...(this.vendorForm.value['VenSupManDetails3'] ? [{ name: this.vendorForm.value['VenSupManDetails3'] }] : [])
    ];
    data.vendor_Name = this.vendorForm.value['vendorName'];
    data.password = this.cryptoJs.Encrypt(this.vendorForm.value['password']);
    data.address = this.vendorForm.value['address'];
    data.mobile = this.vendorForm.value['mobile'];
    // data.doi = dob ? this.toISOLocal(new Date(DOB)).replace(/.\d+Z$/g, "") : this.toISOLocal(new Date((this.farmersDetailsForm.controls.dob.value))).replace(/.\d+Z$/g, "");
    // data.doi = DOB
    //   ? this.toISOLocal(new Date(DOB)).replace(/.\d+Z$/g, '')
    //   : this.toISOLocal(new Date(this.vendorForm.controls.dob.value)).replace(
    //     /.\d+Z$/g,
    //     ''
    //   );
    data.doi = this.datePipe.transform(new Date(this.vendorForm.value['dob']), 'yyyy-MM-dd');
    data.email_ID = this.vendorForm.value['email'];
    data.paN_No = this.vendorForm.value['panNo'];
    data.taN_No = this.vendorForm.value['tanNo'] ? this.vendorForm.value['tanNo'] : '';
    data.gsT_No = this.vendorForm.value['gstNumber'];
    data.ifsC_Code = this.vendorForm.value['iFSCCode'];
    data.bankId = this.vendorForm.value['bankName']?.BANK_ID;
    data.account_No = this.vendorForm.value['bankAccountNumber'];
    data.country = this.vendorForm.value['country'].name;
    data.state = this.vendorForm.value['state'];
    data.city = this.vendorForm.value['city'];
    data.insertAttachments = this.documentList;
    data.progId = this.vendorForm.value['programme']?.map(item => item.Program_Id).join(",");
    data.ddAmount = this.vendorForm.value['ddAmount'];
    data.ddNumber = this.vendorForm.value['ddNumber'];
    data.ddBank = this.vendorForm.value['ddBankName']?.BANK_ID;
    data.ddDate = this.datePipe.transform(new Date(this.vendorForm.value['ddDate']), 'yyyy-MM-dd');
    data.Officical_Email_ID = this.vendorForm.value['officialEmailId'];
    data.networkId = this.ipAddress;
    data.terminalId = this.ipAddress;
    return data;
  }

  _insert(data_) {
    let reqBodyAfterEncypt = {
      "payload": this.cryptoJsService.EncryptPayload(JSON.stringify(data_))
    }

    // console.log('reqBodyAfterEncypt', data_);

    let phNo = data_?.mobile;
    this.loader.start();
    this._personalDetalSer
      .postVendersData(reqBodyAfterEncypt)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
         
          if (data == 'Success') {
            this.vendorForm.reset();
            this.messageService.add({
              severity: 'success',
              summary: 'Success Message',
              detail: data,
            });

            setTimeout(() => { this.router.navigate(['new-registration']) }, 3000)
          } else {
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: data,
            });
          }
          this.activityRecordService.activityRecord(
            phNo,
            'Insert Vendor Registration Details',
            '',
            new Date(),
            data,
            JSON.stringify(data_)
          );
        },
        error: (err) => {
          this.loader.close();
          // this.isLoading = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: 'Data error! Vendors Details not saved.',
          });
          this.activityRecordService.activityRecord(
            phNo,
            'Insert Vendor Registration Details(Error)',
            '',
            new Date(),
            err,
            JSON.stringify(data_)
          );
        },
      });
  }

  isGeneratedFile(data_) {
    this._personalDetalSer
      .postVendersData(data_)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          // this.isLoading = false;
          this._personalDetalSer
            .getFarmerDetails(this.vendorForm.controls.mobile.value)
            .pipe(first())
            .subscribe({
              next: (data) => {
                if (data) {
                  location.reload();
                  window.sessionStorage.setItem(
                    'vendorDetails',
                    JSON.stringify(data.Table[0])
                  );
                }
              },
            });
          if (data == 'Farmer Details Updated Successfully!') {
            this.messageService.add({
              severity: 'success',
              summary: 'Success Message',
              detail: 'Farmer Details updated Successfully.',
            });
          } else {
            this.messageService.add({
              severity: 'error',
              summary: 'Error Message',
              detail: data,
            });
          }
          // this.activityRecordService.activityRecord(phNo, 'Update Personal Details', '', new Date(), data, JSON.stringify(data_))
        },
        error: (err) => {
          this.loader.close();
          // this.isLoading = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: 'Data error! Farmer Details not saved.',
          });
          // this.activityRecordService.activityRecord(phNo, 'Update Personal Details', '', new Date(), err, JSON.stringify(data_));
        },
      });
  }
  onSubmit() {
    let allDocumentsUploaded = true;
    if (this.vendorForm.valid) {
      this.uploadOptions.forEach((option) => {
        if (!(option.DocType == 'Other' || (option.DocType == 'TAN') || (option.DocType == 'Haryana UDYAM Memorandum or UDYAM Registration Certificate' && this.vendorForm.value['vendorType'].ID == 1))) {
          const filtered = this.documentList.filter(
            (doc) => doc.documentType === option.DocType
          );
          if (filtered?.length == 0) {
            this.messageService.add({
              severity: 'error',
              summary: 'Error Message',
              detail: 'Atleast one ' + option.DocType + ' is Needed!',
            });
            allDocumentsUploaded = false;
            return;
          }
        }
      });
      // if(allDocumentsUploaded==true){
      //   const data = this.mapDataToFarmersModel();
      //   let farmerData = JSON.parse(window.sessionStorage.getItem('vendorDetails'));
      //   if (farmerData) {
      //     this._insert(data)
      //   } else {
      //     this._insert(data)
      //   }
      // }

      if (allDocumentsUploaded) {
        const data = this.mapDataToFarmersModel();
        // let farmerData = JSON.parse(
        //   window.sessionStorage.getItem('vendorDetails')
        // );
        // if (data) {
        //   this._insert(data);
        // } else {
        this._insert(data);
        // }

        // this.messageService.add({
        //     severity: 'success',
        //     summary: 'Success',
        //     detail: 'Form submitted successfully!',
        // });
      }
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Error Message',
        detail: 'Please fill all the mandatory fields.',
      });
    }
  }

  onFileChange(event: any) {
    const file = event.target.files[0];
    if (file) {
      this.selectedFile = file;
      // Handle file upload logic or validation here if needed
    } else {
      this.selectedFile = null;
    }
  }

  removeCaptureImg(i) {
    this.documentList.splice(i, 1);
  }
  
  filterBank(event: any) {
    const filtered: any[] = [];
    const query = event.query;
    for (let i = 0; i < this.bankList.length; i++) {
      const bank = this.bankList[i];
      if (bank.Bank_NAME.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(bank);
      }
    }

    this.filteredBankList = filtered;
  }
  getBankNameList() {
    this.productService.getAllBankNames().subscribe((data) => {
      if (data) {
        this.bankList = data;
        this.filteredBankList = data;
        // this.LoadFarmerDetails();
      }
    });
  }

  onClickValidate(val) {
    if(val == 'email'){
      this.otpValidationForm.get('otp').setValidators([
        Validators.required,
        Validators.minLength(4),
        Validators.maxLength(4),
        Validators.pattern('^[0-9]{4}$'),
      ]);
      this.otpValidationForm.get('otp').updateValueAndValidity();
    }else if(val == 'mobile'){
      this.otpValidationForm.get('otp').setValidators([
        Validators.required,
        Validators.minLength(6),
        Validators.maxLength(6),
        Validators.pattern('^[0-9]{6}$'),
      ]);
      this.otpValidationForm.get('otp').updateValueAndValidity();
    }
    
    this.validationType = val;
   
    if (val == 'email') {
      let reqBody = {
        'EmailId': this.vendorForm.value['email']
      }

      this.getEmailOTP(reqBody);
      
    } else if (val == 'mobile') {

      let reqBody = {
        'Mobile': this.cryptoJsService.Encrypt(this.vendorForm.value['mobile'])
      }

      this.getMobileOTP(reqBody);
    }
  }

  onSubmitOTP() {
    if (this.otpValidationForm.valid) {
      if (this.validationType == 'email') {
        let reqBody = {
          'EmailId': this.vendorForm.value['email'],
          'OTP': this.otpValidationForm.value['otp']
        }

        this.submitEmailOTP(reqBody);
      } else if (this.validationType == 'mobile') {
        let reqBody = {
          'MobileNo': this.cryptoJsService.Encrypt(this.vendorForm.value['mobile']),
          'OTP': this.cryptoJsService.Encrypt(this.otpValidationForm.value['otp'])
        }

        this.submitMobileOTP(reqBody);
      }
    }
  }

  getEmailOTP(reqBody) {
    let reqBodyAfterEncypt = {
      "payload": this.cryptoJsService.EncryptPayload(JSON.stringify(reqBody))
    }

    this.loader.start();
    this._personalDetalSer
      .getEmailOTPVendorReg(reqBodyAfterEncypt)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
         
          data = JSON.parse(data)
          data = this.cryptoJsService.DecryptDataPayload(data?.data);

          if (data.startsWith('OTP sent on') || data.startsWith('OTP already sent')) {
            // this.otpSentMessage = `OTP Sucessfully sent on ${reqBody?.EmailId}`;
            this.otpSentMessage = `${data} (${reqBody?.EmailId})`;
            this.openValidationDialog = true;
            this.otpValidationForm.reset();

            this.messageService.add({
              severity: 'success',
              summary: 'Success Message',
              detail: data,
            });

          } else {
            this.openValidationDialog = false;

            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: data,
            });
          }
          // this.activityRecordService.activityRecord(
          //   phNo,
          //   'Email OTP sent for vendor registration',
          //   '',
          //   new Date(),
          //   data,
          //   JSON.stringify(data_)
          // );
        },
        error: (err) => {
          this.loader.close();

          this.openValidationDialog = false;

          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: `Error! ${err}`,
          });
          // this.activityRecordService.activityRecord(
          //   phNo,
          //   'Update Personal Details',
          //   '',
          //   new Date(),
          //   err,
          //   JSON.stringify(data_)
          // );
        },
      });
  }

  getMobileOTP(reqBody) {
    let reqBodyAfterEncypt = {
      "payload": this.cryptoJsService.EncryptPayload(JSON.stringify(reqBody))
    }

    this.loader.start();
    this._personalDetalSer
      .getMobileOTPVendorReg(reqBodyAfterEncypt)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
         
          data = JSON.parse(data)
          data = this.cryptoJsService.DecryptDataPayload(data?.data);

          if (data.startsWith('OTP sent Successfully') || data.startsWith('Already Sent OTP')) {
            // this.otpSentMessage = `OTP Sucessfully sent on ${this.vendorForm.value['mobile']}`;
            this.otpSentMessage = `${data} (${this.vendorForm.value['mobile']})`;
            this.openValidationDialog = true;
            this.otpValidationForm.reset();

            this.messageService.add({
              severity: 'success',
              summary: 'Success Message',
              detail: data,
            });

          } else {
            this.openValidationDialog = false;

            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: data,
            });
          }
        },
        error: (err) => {
          this.loader.close();

          this.openValidationDialog = false;

          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: `Error! ${err}`,
          });
        },
      });
  }

  submitEmailOTP(reqBody) {
    let reqBodyAfterEncypt = {
      "payload": this.cryptoJsService.EncryptPayload(JSON.stringify(reqBody))
    }

    this.loader.start();
    this._personalDetalSer
      .emailOTPValidationVendorReg(reqBodyAfterEncypt)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();

          if (data == 'Success') {
            this.isEmailVerified = true;
            this.openValidationDialog = false;
            this.otpSentMessage = null;
            this.otpValidationForm.reset();

            this.messageService.add({
              severity: 'success',
              summary: 'Success Message',
              detail: data,
            });

          } else {
            this.isEmailVerified = false;

            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: data,
            });
          }
        },
        error: (err) => {
          this.loader.close();

          this.isEmailVerified = false;

          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: `Error! ${err}`,
          });
        },
      });
  }

  submitMobileOTP(reqBody) {
    let reqBodyAfterEncypt = {
      "payload": this.cryptoJsService.EncryptPayload(JSON.stringify(reqBody))
    }

    this.loader.start();
    this._personalDetalSer
      .mobileOTPValidationVendorReg(reqBodyAfterEncypt)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
         
          // data = JSON.parse(data)
          // data = this.cryptoJsService.DecryptDataPayload(data?.data);

          if (data == 'Success') {
            this.isMobileVerified = true;
            this.openValidationDialog = false;
            this.otpSentMessage = null;
            this.otpValidationForm.reset();


            this.messageService.add({
              severity: 'success',
              summary: 'Success Message',
              detail: data,
            });

          } else {
            this.isMobileVerified = false;

            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: data,
            });
          }
        },
        error: (err) => {
          this.loader.close();

          this.isMobileVerified = false;

          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: `Error! ${err}`,
          });
        },
      });
  }

  getComponentMaster() {
    // this.loader.start();
    let sub = this.vendorService
      .getVendorRegProgPriceMaster()
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.programListwithRate = res;
          // this.loader.close();
        },
        error: (err) => {
          // this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });

    this.subscriptions.push(sub);
  }

  onSelectProg(event: any) {
    let val = event?.value;

    const totalAmount = val.reduce((sum, item) => sum + item.Amount, 0);

    this.vendorForm.patchValue({ ddAmount: totalAmount });
    // if(val?.length == 0){
    // }else if(val?.length == 1){
    //   this.vendorForm.patchValue({ ddAmount: '₹ 20,000.00' });
    // }else if(val?.length == 2){
    //   this.vendorForm.patchValue({ ddAmount: '₹ 25,000.00' });
    // }else if(val?.length == 3){
    //   this.vendorForm.patchValue({ ddAmount: '₹ 30,000.00' });
    // }else{
    //   this.vendorForm.patchValue({ ddAmount: '₹ 00,.00' });
    // }
  }

  onRegTypeChange(event){
    // console.log('onRegTypeChange', event.value);
    this.getUploadOptions(event.value?.ID);
  }

  loadVendorRegType() {
    // this.loader.start();
    let sub = this.vendorService
      .getVendorRegTypeMaster()
      .pipe(first())
      .subscribe({
        next: (res) => {
          // this.loader.close();
          
          if(res.length > 0){
            this.vendorTypes = res;
          }else{
            this.vendorTypes = [];
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: `Vendor Types not loaded. ${res}`,
            });
          }
        },
        error: (err) => {
          // this.loader.close();
          this.vendorTypes = [];

          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });

    this.subscriptions.push(sub);
  }

  getIP() {
    if (sessionStorage.getItem('ipAddress')) {
      this.ipAddress = JSON.parse(window.sessionStorage.getItem('ipAddress'));
    } else {
      this.ipService.getIPAddress().subscribe((res: any) => {
        this.ipAddress = res.ip;
        sessionStorage.setItem('ipAddress', JSON.stringify(this.ipAddress));
      });
    }
  }
}
